// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

:root {
  --theia-view-container-title-height: var(--theia-content-line-height);
  --theia-view-container-content-height: calc(
    100% - var(--theia-view-container-title-height)
  );
}

.theia-view-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.theia-view-container > .p-SplitPanel {
  height: 100%;
  width: 100%;
}

.theia-view-container > .p-SplitPanel > .p-SplitPanel-child {
  min-width: 50px;
  min-height: var(--theia-content-line-height);
}

.theia-view-container > .p-SplitPanel > .p-SplitPanel-handle::after {
  min-height: 2px;
  min-width: 2px;
}

.p-SplitPanel > .p-SplitPanel-handle:hover::after {
  background-color: var(--theia-sash-hoverBorder);
  transition-delay: var(--theia-sash-hoverDelay);
}

.p-SplitPanel > .p-SplitPanel-handle:active::after {
  background-color: var(--theia-sash-activeBorder);
  transition-delay: 0s !important;
}

.p-SplitPanel[data-orientation="horizontal"] > .p-SplitPanel-handle::after {
  min-width: var(--theia-sash-width);
}

.p-SplitPanel[data-orientation="vertical"] > .p-SplitPanel-handle::after {
  min-height: var(--theia-sash-width);
}

.theia-view-container .part {
  height: 100%;
}

.theia-view-container-part-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  background: var(--theia-sideBarSectionHeader-background);
  line-height: var(--theia-view-container-title-height);
  z-index: 10;
  color: var(--theia-sideBarSectionHeader-foreground);
  font-weight: 700;
}

.p-Widget > .theia-view-container-part-header {
  box-shadow: 0 1px 0 var(--theia-sideBarSectionHeader-border) inset;
}

.p-Widget.p-first-visible > .theia-view-container-part-header {
  box-shadow: none;
}

.theia-view-container-part-header .theia-ExpansionToggle {
  padding-left: 4px;
}

.theia-view-container
  > .p-SplitPanel[data-orientation="horizontal"]
  .part
  > .theia-header
  .theia-ExpansionToggle::before {
  display: none;
  padding-left: 0px;
}

.theia-view-container
  > .p-SplitPanel[data-orientation="horizontal"]
  .part
  > .theia-header
  .theia-ExpansionToggle {
  padding-left: 0px;
}

.theia-view-container-part-header .label {
  flex: 0;
  flex-basis: fit-content;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theia-view-container-part-header .description {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-left: var(--theia-ui-padding);
  text-transform: none;
  opacity: 0.6;
}

.theia-view-container-part-header .notification-count-container {
  margin-right: 12px;
}

.theia-view-container .part > .body {
  height: var(--theia-view-container-content-height);
  min-width: 50px;
  min-height: 50px;
  position: relative;
}

.theia-view-container .part > .body .theia-tree-source-node-placeholder {
  padding-top: 4px;
  height: 100%;
}

.theia-view-container .part:hover > .body {
  display: block;
}

.theia-view-container .part.drop-target {
  background: var(--theia-list-dropBackground);
  border: var(--theia-border-width) dashed var(--theia-contrastActiveBorder);
  transition-property: top, left, right, bottom;
  transition-duration: 150ms;
  transition-timing-function: ease;
}

.theia-view-container-drag-image {
  background: var(--theia-sideBarSectionHeader-background);
  color: var(--theia-sideBarSectionHeader-foreground);
  line-height: var(--theia-content-line-height);
  position: absolute;
  z-index: 999;
  text-transform: uppercase;
  font-size: var(--theia-ui-font-size0);
  font-weight: 500;
  padding: 0 var(--theia-ui-padding) 0 var(--theia-ui-padding);
}

.p-TabBar-toolbar.theia-view-container-part-title {
  overflow: visible !important;
  padding: 0px;
  padding-right: calc(var(--theia-ui-padding) * 2 / 3);
}

.theia-view-container-part-title {
  display: none;
}

.theia-view-container-part-title.menu-open,
.p-Widget.part:not(.collapsed):hover
  .theia-view-container-part-header
  .theia-view-container-part-title,
.p-Widget.part:not(.collapsed):focus-within
  .theia-view-container-part-header
  .theia-view-container-part-title {
  display: flex;
}

.no-pointer-events {
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/core/src/browser/style/view-container.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAEjF;EACE,qEAAqE;EACrE;;GAEC;AACH;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;EAChD,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,wDAAwD;EACxD,qDAAqD;EACrD,WAAW;EACX,mDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;;EAKE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,0EAA0E;EAC1E,6CAA6C;EAC7C,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;EACxD,mDAAmD;EACnD,6CAA6C;EAC7C,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;EACrC,gBAAgB;EAChB,4DAA4D;AAC9D;;AAEA;EACE,4BAA4B;EAC5B,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n:root {\n  --theia-view-container-title-height: var(--theia-content-line-height);\n  --theia-view-container-content-height: calc(\n    100% - var(--theia-view-container-title-height)\n  );\n}\n\n.theia-view-container {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.theia-view-container > .p-SplitPanel {\n  height: 100%;\n  width: 100%;\n}\n\n.theia-view-container > .p-SplitPanel > .p-SplitPanel-child {\n  min-width: 50px;\n  min-height: var(--theia-content-line-height);\n}\n\n.theia-view-container > .p-SplitPanel > .p-SplitPanel-handle::after {\n  min-height: 2px;\n  min-width: 2px;\n}\n\n.p-SplitPanel > .p-SplitPanel-handle:hover::after {\n  background-color: var(--theia-sash-hoverBorder);\n  transition-delay: var(--theia-sash-hoverDelay);\n}\n\n.p-SplitPanel > .p-SplitPanel-handle:active::after {\n  background-color: var(--theia-sash-activeBorder);\n  transition-delay: 0s !important;\n}\n\n.p-SplitPanel[data-orientation=\"horizontal\"] > .p-SplitPanel-handle::after {\n  min-width: var(--theia-sash-width);\n}\n\n.p-SplitPanel[data-orientation=\"vertical\"] > .p-SplitPanel-handle::after {\n  min-height: var(--theia-sash-width);\n}\n\n.theia-view-container .part {\n  height: 100%;\n}\n\n.theia-view-container-part-header {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background: var(--theia-sideBarSectionHeader-background);\n  line-height: var(--theia-view-container-title-height);\n  z-index: 10;\n  color: var(--theia-sideBarSectionHeader-foreground);\n  font-weight: 700;\n}\n\n.p-Widget > .theia-view-container-part-header {\n  box-shadow: 0 1px 0 var(--theia-sideBarSectionHeader-border) inset;\n}\n\n.p-Widget.p-first-visible > .theia-view-container-part-header {\n  box-shadow: none;\n}\n\n.theia-view-container-part-header .theia-ExpansionToggle {\n  padding-left: 4px;\n}\n\n.theia-view-container\n  > .p-SplitPanel[data-orientation=\"horizontal\"]\n  .part\n  > .theia-header\n  .theia-ExpansionToggle::before {\n  display: none;\n  padding-left: 0px;\n}\n\n.theia-view-container\n  > .p-SplitPanel[data-orientation=\"horizontal\"]\n  .part\n  > .theia-header\n  .theia-ExpansionToggle {\n  padding-left: 0px;\n}\n\n.theia-view-container-part-header .label {\n  flex: 0;\n  flex-basis: fit-content;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theia-view-container-part-header .description {\n  flex: 1;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding-left: var(--theia-ui-padding);\n  text-transform: none;\n  opacity: 0.6;\n}\n\n.theia-view-container-part-header .notification-count-container {\n  margin-right: 12px;\n}\n\n.theia-view-container .part > .body {\n  height: var(--theia-view-container-content-height);\n  min-width: 50px;\n  min-height: 50px;\n  position: relative;\n}\n\n.theia-view-container .part > .body .theia-tree-source-node-placeholder {\n  padding-top: 4px;\n  height: 100%;\n}\n\n.theia-view-container .part:hover > .body {\n  display: block;\n}\n\n.theia-view-container .part.drop-target {\n  background: var(--theia-list-dropBackground);\n  border: var(--theia-border-width) dashed var(--theia-contrastActiveBorder);\n  transition-property: top, left, right, bottom;\n  transition-duration: 150ms;\n  transition-timing-function: ease;\n}\n\n.theia-view-container-drag-image {\n  background: var(--theia-sideBarSectionHeader-background);\n  color: var(--theia-sideBarSectionHeader-foreground);\n  line-height: var(--theia-content-line-height);\n  position: absolute;\n  z-index: 999;\n  text-transform: uppercase;\n  font-size: var(--theia-ui-font-size0);\n  font-weight: 500;\n  padding: 0 var(--theia-ui-padding) 0 var(--theia-ui-padding);\n}\n\n.p-TabBar-toolbar.theia-view-container-part-title {\n  overflow: visible !important;\n  padding: 0px;\n  padding-right: calc(var(--theia-ui-padding) * 2 / 3);\n}\n\n.theia-view-container-part-title {\n  display: none;\n}\n\n.theia-view-container-part-title.menu-open,\n.p-Widget.part:not(.collapsed):hover\n  .theia-view-container-part-header\n  .theia-view-container-part-title,\n.p-Widget.part:not(.collapsed):focus-within\n  .theia-view-container-part-header\n  .theia-view-container-part-title {\n  display: flex;\n}\n\n.no-pointer-events {\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
